<!--
    Program: common error page
    Author: SDL
    Brief: common error page
-->
<template>
<fragment>
    <div id="notfound">
        <div class="notfound">
            <div class="notfound-404">
                <h1>:(</h1>
            </div>
            <h2>Oops... Page not found</h2>
            <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
            <a href="javascript:" v-on:click="goMain">main page</a>
        </div>
    </div>
</fragment>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import _                        from 'lodash';
import store                    from '@/vuex/store';
// import SDLUtil                  from '@/utils/SDLUtil';
import { SDLUtil, MenuUtil }    from '@/utils';

export default {
    data() {
        return {

        };
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            loginSystem: 'getLoginSystem',
            storeParams: 'getParams'
        }),
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
    },
    methods: {
        goMain() {
            store.commit( 'PARAMS', Object.assign( this.storeParams, { menuId : '', menuGrpCd : '', menuGrpDetailCd : '', creationYn : null } ) );
            if(this.loginSystem == 'SUPPORT') {
                this.$router.push(MenuUtil.getSupportMain());
            } else {
                this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
            }
        }
    },
    mounted() {

    },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:400,700");
@import url("https://fonts.googleapis.com/css?family=Passion+One:900");

* {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
}

#notfound {
  position: relative;
  height: 100vh;
}

#notfound .notfound {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

.notfound {
  max-width: 710px;
  width: 100%;
  padding-left: 190px;
  line-height: 1.4;
}

.notfound .notfound-404 {
  position: absolute;
  left: 0;
  top: 0;
  width: 150px;
  height: 150px;
}

.notfound .notfound-404 h1 {
  font-family: 'Passion One', cursive;
  color: #00b5c3;
  font-size: 150px;
  letter-spacing: 15.5px;
  margin: 0px;
  font-weight: 900;
  position: absolute;
  /*left: 50%;*/
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

.notfound h2 {
  font-family: 'Raleway', sans-serif;
  color: #292929;
  font-size: 28px;
    font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2.5px;
  margin-top: 0;
}

.notfound p {
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.notfound a {
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  text-decoration: none;
  text-transform: uppercase;
  background: #fff;
  display: inline-block;
  padding: 15px 30px;
  border-radius: 40px;
  color: #292929;
  font-weight: 700;
  -webkit-box-shadow: 0px 4px 15px -5px rgba(0, 0, 0, 0.3);
          box-shadow: 0px 4px 15px -5px rgba(0, 0, 0, 0.3);
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
}

.notfound a:hover {
  color: #fff;
  background-color: #00b5c3;
}

@media only screen and (max-width: 480px) {
  .notfound {
    text-align: center;
  }
  .notfound .notfound-404 {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
  }
  .notfound {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/EmptyPage.vue